"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _grayPercentage = require("gray-percentage");

var _grayPercentage2 = _interopRequireDefault(_grayPercentage);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var theme = {
  title: "Wordpress Theme 2014",
  baseFontSize: "16px",
  baseLineHeight: 1.5,
  googleFonts: [{
    name: "Lato",
    styles: ["300", "300i", "400", "400i", "600"]
  }],
  headerFontFamily: ["Lato", "serif"],
  bodyFontFamily: ["Lato", "serif"],
  bodyColor: "hsla(0,0%,0%,0.83)",
  headerWeight: 600,
  bodyWeight: 400,
  boldWeight: 600,
  overrideStyles: function overrideStyles(_ref, options) {
    var adjustFontSizeTo = _ref.adjustFontSizeTo,
        scale = _ref.scale,
        rhythm = _ref.rhythm;
    return {
      "h1,h2,h3,h4,h5,h6": {
        marginTop: rhythm(1.5),
        marginBottom: rhythm(0.5)
      },
      "ul,ol": {
        marginLeft: rhythm(5 / 6)
      },
      // children ol, ul
      "li>ol,li>ul": {
        marginLeft: rhythm(5 / 6),
        marginBottom: 0
      },
      // Blockquote styles.
      blockquote: _extends({}, scale(1 / 5), {
        fontWeight: 300,
        color: (0, _grayPercentage2["default"])(46),
        fontStyle: "italic",
        marginLeft: 0,
        marginRight: 0
      }),
      "blockquote > :last-child": {
        marginBottom: 0
      },
      "blockquote cite": _extends({}, adjustFontSizeTo(options.baseFontSize), {
        color: options.bodyColor,
        fontStyle: "normal",
        fontWeight: options.bodyWeight
      }),
      "blockquote cite:before": {
        content: '"— "'
      }
    };
  }
};
exports["default"] = theme;